import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function AuthServerTableRowSkeleton({ index }) {
    return (
        <tr key={index}>
            <td><Skeleton variant="text" width="80%" height={24} /></td>
            <td><Skeleton variant="text" width="60%" height={24} /></td>
            <td><Skeleton variant="text" width="60%" height={24} /></td>
            <td><Skeleton variant="text" width="80%" height={24} /></td>
            <td>
                <div className="oct_skeleton-flex-center-gap">
                    <Skeleton variant="circular" width={16} height={16} />
                    <Skeleton variant="text" width={60} height={24} />
                </div>
            </td>
            <td>
                <button className="oct_dropdown-trigger-v2 oct_skeleton-dropdown-btn" disabled>
                    <Skeleton variant="circular" width={24} height={24} />
                </button>
            </td>
        </tr>
    );
}

export default AuthServerTableRowSkeleton;
